/* eslint-disable no-param-reassign */
/* eslint-disable no-async-promise-executor */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-30 11:02:25
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-26 15:30:59
 * @FilePath: /roboneo-web/src/api/canvasRquest.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { serverGet } from './serverFetch';
import APP from './api';

import type {
  ActivityItem,
  OverseaFeatureItem,
} from './api.type';

/** 服务端请求的公共选项 */
export interface ServerRequestCommonOptions {
  /** 原始 cookie 字符串 */
  cookie?: string;
  /** 国家代码（从 server.ts 通过 IP 解析获取） */
  countryCode?: string;
  /** SSR 请求超时时间，首页等首屏链路可按业务设置更短的降级阈值。 */
  timeout?: number;
}

/**
 * 海外ssr菜单请求
 *
 * @export
 * @param {ServerRequestCommonOptions} [options] 请求选项，包含 cookie 和 countryCode
 * @return {*}  {Promise<{list: OverseaFeatureItem[]}>}
 */
export async function fetchOverseaMenus(options?: ServerRequestCommonOptions): Promise<{ list: {
  category: 'Product' | 'Blog';
  list: OverseaFeatureItem[];
}[]; }> {
  try {
    const res = await serverGet(APP.roboneo.api.overseaFeatures, undefined, options);
    if (res.status === 200 && res.data.code === 0) {
      return res?.data?.data;
    }
    return await Promise.reject(res);
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * 活动列表信息
 *
 * @export
 * @param {string} position 位置
 * @param {ServerRequestCommonOptions} [options] 请求选项，包含 cookie 和 countryCode
 * @return {*}  {Promise<{ list: ActivityItem[] }>}
 */
export async function fetchActivityList(
  position: 'home_northeast' | 'official_home_top',
  options?: ServerRequestCommonOptions,
): Promise<{ list: ActivityItem[]; }> {
  try {
    const res = await serverGet(APP.roboneo.api.activityList, { position }, options);
    if (res.status === 200 && res.data.code === 0) {
      return res?.data?.data;
    }
    return await Promise.reject(res);
  } catch (err) {
    return Promise.reject(err);
  }
}
